export default __webpack_public_path__ + "static/ApercuLAPhil-Regular-69c3b1e1ca1b381cca0f279bddbdafe2.eot";